import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { Edit } from '@mui/icons-material';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { FiltersFormPerson } from 'shell/view-models/search-anpr';
import { DefaultFilterTable } from 'shell/constants/person-search';

const ActionsList = ({ cell, pathname }: ActionProps): React.ReactElement => {
  const navigate = useNavigate();
  const personFilterTable = useFilterTable<FiltersFormPerson>();
  const onEditPress = useEventCallback(() => {
    return new Promise((resolve) => {
      personFilterTable.setValues(DefaultFilterTable);
      navigate({
        pathname,
        search: `?${createSearchParams({
          codiceFiscale: cell?.fiscalCode || '',
        })}`,
      });
      resolve(cell);
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onEditPress();
        }}
        aria-label="Visualizza elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <Edit />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list Document - residency permit page component';

export default ActionsList;
